import { render, staticRenderFns } from "./BankingDetail.vue?vue&type=template&id=2a803210"
import script from "./BankingDetail.vue?vue&type=script&lang=js"
export * from "./BankingDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports